import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {User} from '../interface/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private baseUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient) { }

  get(id: number): Observable<any>{
    return this.http.get(`${this.baseUrl}/get/user/${id}`);
  }

  getCollection(): Observable<any>{
    return this.http.get(`${this.baseUrl}/get/users`);
  }

  getCurrentYear(): Observable<any>{
    return this.http.get(`${this.baseUrl}/get/security/dashboard/current-session`);
  }

  getNumberOfUsers(): Observable<any>{
    return this.http.get(`${this.baseUrl}/get/security/dashboard/number-of-users`);
  }

  getCurrentUserBranches(): Observable<any>{
    return this.http.get(`${this.baseUrl}/get/user-branches`);
  }

  create(data: any): Observable<any>{
    return this.http.post(`${this.baseUrl}/create/user`, data);
  }

  edit(id: number, data: any): Observable<any>{
    return this.http.post(`${this.baseUrl}/edit/user/${id}`, data);
  }

  delete(id: number): Observable<any>{
    return this.http.delete(`${this.baseUrl}/delete/user/${id}`);
  }

  getUser(id: number, data: any): Observable<any>{
    return this.http.put(`${this.baseUrl}/get/user/${id}`, data);
  }

  getUserId(id: number): Observable<any>{
    return this.http.get(`${this.baseUrl}/get/user/by/${id}`);
  }

  deleteMultipleUser(ids: number[]): Observable<User[]>{
    const options = {body: ids};
    return this.http.delete<any>(`${this.baseUrl}/delete/states`, options);

  }

  userPasswordUpdate(id: number, data: any): Observable<any>{
    return this.http.post(`${this.baseUrl}/update/password/user/${id}`, data);
  }

  userBranchesUpdate(id: number, data: any): Observable<any>{
    return this.http.put(`${this.baseUrl}/update/user-branches/${id}`, data);
  }

  getInstitutionList(): Observable<any>{
    return this.http.get(`${this.baseUrl}/institution/get`);
  }

}
